import "./main.css";
import {Item as $23896c8062ba3967$re_export$Item, Section as $23896c8062ba3967$re_export$Section} from "@react-stately/collections";
import $3toCD$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $3toCD$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import {useSlotProps as $3toCD$useSlotProps, useDOMRef as $3toCD$useDOMRef, useUnwrapDOMRef as $3toCD$useUnwrapDOMRef, useIsMobileDevice as $3toCD$useIsMobileDevice, dimensionValue as $3toCD$dimensionValue, classNames as $3toCD$classNames, SlotProvider as $3toCD$SlotProvider} from "@react-spectrum/utils";
import {Field as $3toCD$Field} from "@react-spectrum/label";
import {FieldButton as $3toCD$FieldButton} from "@react-spectrum/button";
import {useSelect as $3toCD$useSelect, HiddenSelect as $3toCD$HiddenSelect} from "@react-aria/select";
import {useListBoxLayout as $3toCD$useListBoxLayout, ListBoxBase as $3toCD$ListBoxBase} from "@react-spectrum/listbox";
import {useId as $3toCD$useId, useResizeObserver as $3toCD$useResizeObserver, useLayoutEffect as $3toCD$useLayoutEffect, mergeProps as $3toCD$mergeProps} from "@react-aria/utils";
import {Tray as $3toCD$Tray, Popover as $3toCD$Popover} from "@react-spectrum/overlays";
import {useHover as $3toCD$useHover, PressResponder as $3toCD$PressResponder} from "@react-aria/interactions";
import {ProgressCircle as $3toCD$ProgressCircle} from "@react-spectrum/progress";
import $3toCD$react, {useRef as $3toCD$useRef, useState as $3toCD$useState, useCallback as $3toCD$useCallback} from "react";
import {Text as $3toCD$Text} from "@react-spectrum/text";
import {useFormProps as $3toCD$useFormProps} from "@react-spectrum/form";
import {useLocalizedStringFormatter as $3toCD$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useProviderProps as $3toCD$useProviderProps, useProvider as $3toCD$useProvider} from "@react-spectrum/provider";
import {useSelectState as $3toCD$useSelectState} from "@react-stately/select";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





var $45fc5064af81e0a8$exports = {};
var $d1a348ee160b1c35$exports = {};
$d1a348ee160b1c35$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "placeholder": `\u{62D}\u{62F}\u{62F} \u{62E}\u{64A}\u{627}\u{631}\u{64B}\u{627}...`
};


var $6f4b5567d8931b2c$exports = {};
$6f4b5567d8931b2c$exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "placeholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`
};


var $413f5c9b05a53d70$exports = {};
$413f5c9b05a53d70$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "placeholder": `Vyberte vhodnou mo\u{17E}nost...`
};


var $23214587b45d0c7a$exports = {};
$23214587b45d0c7a$exports = {
    "loading": `Indl\xe6ser ...`,
    "placeholder": `V\xe6lg en mulighed ...`
};


var $291e2fb947064c57$exports = {};
$291e2fb947064c57$exports = {
    "loading": `Laden...`,
    "placeholder": `Option ausw\xe4hlen...`
};


var $c5247287ce725677$exports = {};
$c5247287ce725677$exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "placeholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5}\u{2026}`
};


var $3d85b21727aef233$exports = {};
$3d85b21727aef233$exports = {
    "placeholder": `Select an option\u{2026}`,
    "loading": `Loading\u{2026}`
};


var $573c338a19d2e44a$exports = {};
$573c338a19d2e44a$exports = {
    "loading": `Cargando\u{2026}`,
    "placeholder": `Seleccione una opci\xf3n\u{2026}`
};


var $52537a7562a0fcd4$exports = {};
$52537a7562a0fcd4$exports = {
    "loading": `Laadimine...`,
    "placeholder": `Valige valikuline...`
};


var $f128a549f8c2b170$exports = {};
$f128a549f8c2b170$exports = {
    "loading": `Ladataan\u{2026}`,
    "placeholder": `Valitse vaihtoehto...`
};


var $f69e7a23857afc72$exports = {};
$f69e7a23857afc72$exports = {
    "loading": `Chargement...`,
    "placeholder": `S\xe9lectionnez une option...`
};


var $cf880887f8515ea2$exports = {};
$cf880887f8515ea2$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "placeholder": `\u{5D1}\u{5D7}\u{5E8} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA}...`
};


var $1f679bbb79879af2$exports = {};
$1f679bbb79879af2$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Odaberite opciju`
};


var $fc9bc2ec180ca71d$exports = {};
$fc9bc2ec180ca71d$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "placeholder": `V\xe1lasszon egy opci\xf3t\u{2026}`
};


var $9fbc1ff7e87407ac$exports = {};
$9fbc1ff7e87407ac$exports = {
    "loading": `Caricamento...`,
    "placeholder": `Seleziona un\u{2019}opzione...`
};


var $96673b78dbaf44b6$exports = {};
$96673b78dbaf44b6$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "placeholder": `\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{9078}\u{629E}...`
};


var $beddb5ded972a868$exports = {};
$beddb5ded972a868$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}`,
    "placeholder": `\u{C120}\u{D0DD} \u{C0AC}\u{D56D} \u{C120}\u{D0DD}`
};


var $2ac19a654f19cde2$exports = {};
$2ac19a654f19cde2$exports = {
    "loading": `\u{12E}keliama...`,
    "placeholder": `Pasirinkite parinkt\u{12F}...`
};


var $844be78af2d57459$exports = {};
$844be78af2d57459$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "placeholder": `Atlasiet opciju...`
};


var $42b05097f4e27f73$exports = {};
$42b05097f4e27f73$exports = {
    "loading": `Laster inn ...`,
    "placeholder": `Velg et alternativ...`
};


var $74dd3f417665b06f$exports = {};
$74dd3f417665b06f$exports = {
    "loading": `Laden...`,
    "placeholder": `Optie selecteren...`
};


var $6221651ca0306be3$exports = {};
$6221651ca0306be3$exports = {
    "loading": `\u{141}adowanie...`,
    "placeholder": `Wybierz opcj\u{119}...`
};


var $45bd58553e21ec53$exports = {};
$45bd58553e21ec53$exports = {
    "loading": `Carregando...`,
    "placeholder": `Selecione uma op\xe7\xe3o...`
};


var $7ae7985d84009e3a$exports = {};
$7ae7985d84009e3a$exports = {
    "loading": `A carregar...`,
    "placeholder": `Selecionar uma op\xe7\xe3o...`
};


var $c83f9725f6024f47$exports = {};
$c83f9725f6024f47$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "placeholder": `Selecta\u{21B}i o op\u{21B}iune`
};


var $0fb522ae7b51fefd$exports = {};
$0fb522ae7b51fefd$exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "placeholder": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}...`
};


var $5ca94db2a021a726$exports = {};
$5ca94db2a021a726$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "placeholder": `Vyberte mo\u{17E}nos\u{165}...`
};


var $2c7a753ed24e9851$exports = {};
$2c7a753ed24e9851$exports = {
    "loading": `Nalaganje...`,
    "placeholder": `Izberite mo\u{17E}nost`
};


var $14a1d1750c9de591$exports = {};
$14a1d1750c9de591$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Izaberite opciju`
};


var $bf3f89a84488b301$exports = {};
$bf3f89a84488b301$exports = {
    "loading": `L\xe4ser in...`,
    "placeholder": `V\xe4lj ett alternativ...`
};


var $1ff90abddf42fc72$exports = {};
$1ff90abddf42fc72$exports = {
    "loading": `Y\xfckleniyor...`,
    "placeholder": `Bir se\xe7im yap\u{131}n\u{2026}`
};


var $4f07d8c17926a679$exports = {};
$4f07d8c17926a679$exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "placeholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{43E}\u{43F}\u{446}\u{456}\u{44E}...`
};


var $07a8d3b903fa886f$exports = {};
$07a8d3b903fa886f$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "placeholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9009}\u{9879}...`
};


var $e1416a5539091e36$exports = {};
$e1416a5539091e36$exports = {
    "loading": `\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    "placeholder": `\u{9078}\u{53D6}\u{4E00}\u{500B}\u{9078}\u{9805}`
};


$45fc5064af81e0a8$exports = {
    "ar-AE": $d1a348ee160b1c35$exports,
    "bg-BG": $6f4b5567d8931b2c$exports,
    "cs-CZ": $413f5c9b05a53d70$exports,
    "da-DK": $23214587b45d0c7a$exports,
    "de-DE": $291e2fb947064c57$exports,
    "el-GR": $c5247287ce725677$exports,
    "en-US": $3d85b21727aef233$exports,
    "es-ES": $573c338a19d2e44a$exports,
    "et-EE": $52537a7562a0fcd4$exports,
    "fi-FI": $f128a549f8c2b170$exports,
    "fr-FR": $f69e7a23857afc72$exports,
    "he-IL": $cf880887f8515ea2$exports,
    "hr-HR": $1f679bbb79879af2$exports,
    "hu-HU": $fc9bc2ec180ca71d$exports,
    "it-IT": $9fbc1ff7e87407ac$exports,
    "ja-JP": $96673b78dbaf44b6$exports,
    "ko-KR": $beddb5ded972a868$exports,
    "lt-LT": $2ac19a654f19cde2$exports,
    "lv-LV": $844be78af2d57459$exports,
    "nb-NO": $42b05097f4e27f73$exports,
    "nl-NL": $74dd3f417665b06f$exports,
    "pl-PL": $6221651ca0306be3$exports,
    "pt-BR": $45bd58553e21ec53$exports,
    "pt-PT": $7ae7985d84009e3a$exports,
    "ro-RO": $c83f9725f6024f47$exports,
    "ru-RU": $0fb522ae7b51fefd$exports,
    "sk-SK": $5ca94db2a021a726$exports,
    "sl-SI": $2c7a753ed24e9851$exports,
    "sr-SP": $14a1d1750c9de591$exports,
    "sv-SE": $bf3f89a84488b301$exports,
    "tr-TR": $1ff90abddf42fc72$exports,
    "uk-UA": $4f07d8c17926a679$exports,
    "zh-CN": $07a8d3b903fa886f$exports,
    "zh-TW": $e1416a5539091e36$exports
};








var $3c14925a8a65017e$exports = {};

$parcel$export($3c14925a8a65017e$exports, "focus-ring", () => $3c14925a8a65017e$export$f39a09f249340e2a, (v) => $3c14925a8a65017e$export$f39a09f249340e2a = v);
$parcel$export($3c14925a8a65017e$exports, "i18nFontFamily", () => $3c14925a8a65017e$export$8c4ee2c50c22c514, (v) => $3c14925a8a65017e$export$8c4ee2c50c22c514 = v);
$parcel$export($3c14925a8a65017e$exports, "is-disabled", () => $3c14925a8a65017e$export$d35bc1e505d1ebbf, (v) => $3c14925a8a65017e$export$d35bc1e505d1ebbf = v);
$parcel$export($3c14925a8a65017e$exports, "is-hovered", () => $3c14925a8a65017e$export$b8813cd5d7824ce7, (v) => $3c14925a8a65017e$export$b8813cd5d7824ce7 = v);
$parcel$export($3c14925a8a65017e$exports, "is-invalid", () => $3c14925a8a65017e$export$14a30de2866685fa, (v) => $3c14925a8a65017e$export$14a30de2866685fa = v);
$parcel$export($3c14925a8a65017e$exports, "is-placeholder", () => $3c14925a8a65017e$export$e5b2f5233e4e5194, (v) => $3c14925a8a65017e$export$e5b2f5233e4e5194 = v);
$parcel$export($3c14925a8a65017e$exports, "is-selected", () => $3c14925a8a65017e$export$1e0fb04f31d3c22a, (v) => $3c14925a8a65017e$export$1e0fb04f31d3c22a = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown", () => $3c14925a8a65017e$export$f33c6833ddc773bd, (v) => $3c14925a8a65017e$export$f33c6833ddc773bd = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown--quiet", () => $3c14925a8a65017e$export$b2306417a70c7a62, (v) => $3c14925a8a65017e$export$b2306417a70c7a62 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-avatar", () => $3c14925a8a65017e$export$f8e5a201376aedb0, (v) => $3c14925a8a65017e$export$f8e5a201376aedb0 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-chevron", () => $3c14925a8a65017e$export$abbb0cf96dbbb8a0, (v) => $3c14925a8a65017e$export$abbb0cf96dbbb8a0 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-fieldWrapper--positionSide", () => $3c14925a8a65017e$export$c0b4e9596538c7b1, (v) => $3c14925a8a65017e$export$c0b4e9596538c7b1 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-fieldWrapper--quiet", () => $3c14925a8a65017e$export$66ddc2410b0e9eba, (v) => $3c14925a8a65017e$export$66ddc2410b0e9eba = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-invalidIcon", () => $3c14925a8a65017e$export$a32fdb5a063ea755, (v) => $3c14925a8a65017e$export$a32fdb5a063ea755 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-label", () => $3c14925a8a65017e$export$1235a00795b885e7, (v) => $3c14925a8a65017e$export$1235a00795b885e7 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-popover--quiet", () => $3c14925a8a65017e$export$cbeaf986973c0633, (v) => $3c14925a8a65017e$export$cbeaf986973c0633 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-progressCircle", () => $3c14925a8a65017e$export$18281c34cabbd13f, (v) => $3c14925a8a65017e$export$18281c34cabbd13f = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Dropdown-trigger", () => $3c14925a8a65017e$export$37a6d27a7cb47ce5, (v) => $3c14925a8a65017e$export$37a6d27a7cb47ce5 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Field", () => $3c14925a8a65017e$export$f6d480ae1e56eba0, (v) => $3c14925a8a65017e$export$f6d480ae1e56eba0 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-FocusRing-ring", () => $3c14925a8a65017e$export$4109102f950813a6, (v) => $3c14925a8a65017e$export$4109102f950813a6 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-FocusRing", () => $3c14925a8a65017e$export$24c7f46a6e3605dd, (v) => $3c14925a8a65017e$export$24c7f46a6e3605dd = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-FocusRing--quiet", () => $3c14925a8a65017e$export$2927016961429360, (v) => $3c14925a8a65017e$export$2927016961429360 = v);
$parcel$export($3c14925a8a65017e$exports, "spectrum-Icon", () => $3c14925a8a65017e$export$d374b04f30360026, (v) => $3c14925a8a65017e$export$d374b04f30360026 = v);
var $3c14925a8a65017e$export$f39a09f249340e2a;
var $3c14925a8a65017e$export$8c4ee2c50c22c514;
var $3c14925a8a65017e$export$d35bc1e505d1ebbf;
var $3c14925a8a65017e$export$b8813cd5d7824ce7;
var $3c14925a8a65017e$export$14a30de2866685fa;
var $3c14925a8a65017e$export$e5b2f5233e4e5194;
var $3c14925a8a65017e$export$1e0fb04f31d3c22a;
var $3c14925a8a65017e$export$f33c6833ddc773bd;
var $3c14925a8a65017e$export$b2306417a70c7a62;
var $3c14925a8a65017e$export$f8e5a201376aedb0;
var $3c14925a8a65017e$export$abbb0cf96dbbb8a0;
var $3c14925a8a65017e$export$c0b4e9596538c7b1;
var $3c14925a8a65017e$export$66ddc2410b0e9eba;
var $3c14925a8a65017e$export$a32fdb5a063ea755;
var $3c14925a8a65017e$export$1235a00795b885e7;
var $3c14925a8a65017e$export$cbeaf986973c0633;
var $3c14925a8a65017e$export$18281c34cabbd13f;
var $3c14925a8a65017e$export$37a6d27a7cb47ce5;
var $3c14925a8a65017e$export$f6d480ae1e56eba0;
var $3c14925a8a65017e$export$4109102f950813a6;
var $3c14925a8a65017e$export$24c7f46a6e3605dd;
var $3c14925a8a65017e$export$2927016961429360;
var $3c14925a8a65017e$export$d374b04f30360026;
$3c14925a8a65017e$export$f39a09f249340e2a = `PBsjDW_focus-ring`;
$3c14925a8a65017e$export$8c4ee2c50c22c514 = `PBsjDW_i18nFontFamily`;
$3c14925a8a65017e$export$d35bc1e505d1ebbf = `PBsjDW_is-disabled`;
$3c14925a8a65017e$export$b8813cd5d7824ce7 = `PBsjDW_is-hovered`;
$3c14925a8a65017e$export$14a30de2866685fa = `PBsjDW_is-invalid`;
$3c14925a8a65017e$export$e5b2f5233e4e5194 = `PBsjDW_is-placeholder`;
$3c14925a8a65017e$export$1e0fb04f31d3c22a = `PBsjDW_is-selected`;
$3c14925a8a65017e$export$f33c6833ddc773bd = `PBsjDW_spectrum-Dropdown`;
$3c14925a8a65017e$export$b2306417a70c7a62 = `PBsjDW_spectrum-Dropdown--quiet`;
$3c14925a8a65017e$export$f8e5a201376aedb0 = `PBsjDW_spectrum-Dropdown-avatar`;
$3c14925a8a65017e$export$abbb0cf96dbbb8a0 = `PBsjDW_spectrum-Dropdown-chevron`;
$3c14925a8a65017e$export$c0b4e9596538c7b1 = `PBsjDW_spectrum-Dropdown-fieldWrapper--positionSide`;
$3c14925a8a65017e$export$66ddc2410b0e9eba = `PBsjDW_spectrum-Dropdown-fieldWrapper--quiet`;
$3c14925a8a65017e$export$a32fdb5a063ea755 = `PBsjDW_spectrum-Dropdown-invalidIcon`;
$3c14925a8a65017e$export$1235a00795b885e7 = `PBsjDW_spectrum-Dropdown-label`;
$3c14925a8a65017e$export$cbeaf986973c0633 = `PBsjDW_spectrum-Dropdown-popover--quiet`;
$3c14925a8a65017e$export$18281c34cabbd13f = `PBsjDW_spectrum-Dropdown-progressCircle`;
$3c14925a8a65017e$export$37a6d27a7cb47ce5 = `PBsjDW_spectrum-Dropdown-trigger`;
$3c14925a8a65017e$export$f6d480ae1e56eba0 = `PBsjDW_spectrum-Field`;
$3c14925a8a65017e$export$4109102f950813a6 = `PBsjDW_spectrum-FocusRing-ring`;
$3c14925a8a65017e$export$24c7f46a6e3605dd = `PBsjDW_spectrum-FocusRing ${$3c14925a8a65017e$export$4109102f950813a6}`;
$3c14925a8a65017e$export$2927016961429360 = `PBsjDW_spectrum-FocusRing--quiet`;
$3c14925a8a65017e$export$d374b04f30360026 = `PBsjDW_spectrum-Icon`;







function $51664a9007a3c6f9$var$Picker(props, ref) {
    props = (0, $3toCD$useSlotProps)(props, "picker");
    props = (0, $3toCD$useProviderProps)(props);
    props = (0, $3toCD$useFormProps)(props);
    let stringFormatter = (0, $3toCD$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($45fc5064af81e0a8$exports))), "@react-spectrum/picker");
    let { autoComplete: autoComplete, isDisabled: isDisabled, direction: direction = "bottom", align: align = "start", shouldFlip: shouldFlip = true, placeholder: placeholder = stringFormatter.format("placeholder"), isQuiet: isQuiet, label: label, labelPosition: labelPosition = "top", menuWidth: menuWidth, name: name, autoFocus: autoFocus } = props;
    let state = (0, $3toCD$useSelectState)(props);
    let domRef = (0, $3toCD$useDOMRef)(ref);
    let popoverRef = (0, $3toCD$useRef)();
    let triggerRef = (0, $3toCD$useRef)();
    let unwrappedTriggerRef = (0, $3toCD$useUnwrapDOMRef)(triggerRef);
    let listboxRef = (0, $3toCD$useRef)();
    let isLoadingInitial = props.isLoading && state.collection.size === 0;
    let isLoadingMore = props.isLoading && state.collection.size > 0;
    let progressCircleId = (0, $3toCD$useId)();
    // We create the listbox layout in Picker and pass it to ListBoxBase below
    // so that the layout information can be cached even while the listbox is not mounted.
    // We also use the layout as the keyboard delegate for type to select.
    let layout = (0, $3toCD$useListBoxLayout)(state, isLoadingMore);
    let { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $3toCD$useSelect)({
        ...props,
        "aria-describedby": isLoadingInitial ? progressCircleId : undefined,
        keyboardDelegate: layout
    }, state, unwrappedTriggerRef);
    let isMobile = (0, $3toCD$useIsMobileDevice)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $3toCD$useHover)({
        isDisabled: isDisabled
    });
    // On small screen devices, the listbox is rendered in a tray, otherwise a popover.
    let listbox = /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$ListBoxBase), {
        ...menuProps,
        ref: listboxRef,
        disallowEmptySelection: true,
        autoFocus: state.focusStrategy || true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        width: isMobile ? "100%" : undefined,
        // Set max height: inherit so Tray scrolling works
        UNSAFE_style: {
            maxHeight: "inherit"
        },
        isLoading: props.isLoading,
        onLoadMore: props.onLoadMore
    });
    // Measure the width of the button to inform the width of the menu (below).
    let [buttonWidth, setButtonWidth] = (0, $3toCD$useState)(null);
    let { scale: scale } = (0, $3toCD$useProvider)();
    let onResize = (0, $3toCD$useCallback)(()=>{
        if (!isMobile && unwrappedTriggerRef.current) {
            let width = unwrappedTriggerRef.current.offsetWidth;
            setButtonWidth(width);
        }
    }, [
        unwrappedTriggerRef,
        setButtonWidth,
        isMobile
    ]);
    (0, $3toCD$useResizeObserver)({
        ref: unwrappedTriggerRef,
        onResize: onResize
    });
    (0, $3toCD$useLayoutEffect)(onResize, [
        scale,
        state.selectedKey,
        onResize
    ]);
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$Tray), {
        state: state
    }, listbox);
    else {
        // If quiet, use the default width, otherwise match the width of the button. This can be overridden by the menuWidth prop.
        // Always have a minimum width of the button width. When quiet, there is an extra offset to add.
        // Not using style props for this because they don't support `calc`.
        let width = isQuiet ? null : buttonWidth;
        let style = {
            width: menuWidth ? (0, $3toCD$dimensionValue)(menuWidth) : width,
            minWidth: isQuiet ? `calc(${buttonWidth}px + calc(2 * var(--spectrum-dropdown-quiet-offset)))` : buttonWidth
        };
        overlay = /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$Popover), {
            UNSAFE_style: style,
            UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-popover", {
                "spectrum-Dropdown-popover--quiet": isQuiet
            }),
            ref: popoverRef,
            placement: `${direction} ${align}`,
            shouldFlip: shouldFlip,
            hideArrow: true,
            state: state,
            triggerRef: unwrappedTriggerRef,
            scrollRef: listboxRef
        }, listbox);
    }
    let contents = state.selectedItem ? state.selectedItem.rendered : placeholder;
    if (typeof contents === "string") contents = /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$Text), null, contents);
    let picker = /*#__PURE__*/ (0, $3toCD$react).createElement("div", {
        className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown", {
            "is-invalid": isInvalid && !isDisabled,
            "is-disabled": isDisabled,
            "spectrum-Dropdown--quiet": isQuiet
        })
    }, /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$HiddenSelect), {
        autoComplete: autoComplete,
        isDisabled: isDisabled,
        state: state,
        triggerRef: unwrappedTriggerRef,
        label: label,
        name: name
    }), /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$PressResponder), (0, $3toCD$mergeProps)(hoverProps, triggerProps), /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$FieldButton), {
        ref: triggerRef,
        isActive: state.isOpen,
        isQuiet: isQuiet,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        autoFocus: autoFocus,
        UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-trigger", {
            "is-hovered": isHovered
        })
    }, /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$SlotProvider), {
        slots: {
            icon: {
                UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Icon"),
                size: "S"
            },
            avatar: {
                UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-avatar"),
                size: "avatar-size-100"
            },
            text: {
                ...valueProps,
                UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-label", {
                    "is-placeholder": !state.selectedItem
                })
            },
            description: {
                isHidden: true
            }
        }
    }, contents), isLoadingInitial && /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$ProgressCircle), {
        id: progressCircleId,
        isIndeterminate: true,
        size: "S",
        "aria-label": stringFormatter.format("loading"),
        UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-progressCircle")
    }), isInvalid && !isLoadingInitial && !isDisabled && /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$spectrumiconsuiAlertMedium), {
        UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-invalidIcon")
    }), /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Dropdown-chevron")
    }))), state.collection.size === 0 ? null : overlay);
    let wrapperClassName = (0, $3toCD$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($3c14925a8a65017e$exports))), "spectrum-Field", {
        "spectrum-Dropdown-fieldWrapper--quiet": isQuiet,
        "spectrum-Dropdown-fieldWrapper--positionSide": labelPosition === "side"
    });
    return /*#__PURE__*/ (0, $3toCD$react).createElement((0, $3toCD$Field), {
        ...props,
        ref: domRef,
        wrapperClassName: wrapperClassName,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        showErrorIcon: false,
        includeNecessityIndicatorInAccessibilityName: true,
        elementType: "span"
    }, picker);
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const $51664a9007a3c6f9$export$ba25329847403e11 = /*#__PURE__*/ (0, $3toCD$react).forwardRef($51664a9007a3c6f9$var$Picker);





export {$51664a9007a3c6f9$export$ba25329847403e11 as Picker, $23896c8062ba3967$re_export$Item as Item, $23896c8062ba3967$re_export$Section as Section};
//# sourceMappingURL=module.js.map
